import { render } from "./AudioEditor.vue?vue&type=template&id=bd0f197e&scoped=true"
import script from "./AudioEditor.vue?vue&type=script&lang=js"
export * from "./AudioEditor.vue?vue&type=script&lang=js"

import "./AudioEditor.vue?vue&type=style&index=0&id=bd0f197e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0f197e"]])

export default __exports__